const boardType = [
  { value: "AI", label: "AI" },
  { value: "RO", label: "RO" },
  { value: "BB", label: "BB" },
  { value: "HB", label: "HB" },
  { value: "FB", label: "FB" },
  { value: "UAI", label: "UAI" },
];

export default boardType;
